import {Image as ReactBrandImage, type ImageProps} from '@primer/react-brand/esm'

export const Image = ({
  src,
  alt,
  loading = 'lazy',
  decoding = 'async',
  ...rest
}: Omit<ImageProps, 'src'> & {src?: string}) => {
  // If src is undefined, don't render anything
  if (!src) {
    return null
  }

  return (
    <ReactBrandImage src={src} alt={alt} loading={loading} decoding={decoding} {...(rest as Partial<ImageProps>)} />
  )
}
